var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expect"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../assets/icon @2x.png")}}),_vm._v(" "),_c('p',[_vm._v("此功能正在紧张开发中")]),_vm._v(" "),_c('p',[_vm._v("敬请期待...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1f1b41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Expect.vue
// module id = null
// module chunks = 